module.exports = require("@wix/wix-ui-santa/skinDataCustomizations.bundle.min");;